import {Component, OnInit} from '@angular/core';
import {CardRenewalImport} from '../../../../dto/card-renewal-import';
import {CardRenewal} from '../../../../dto/card-renewal';
import {CardRenewalImportError} from '../../../../dto/card-renewal-import-error';
import {MatTableDataSource} from '@angular/material/table';
import {DateFormats} from '../../../../providers/app-date-adapter';
import {CardRenewalService} from '../../../services/card-renewal.service';
import {ActivatedRoute} from '@angular/router';
import {DatePipe, Location} from '@angular/common';
import {Card} from '../../../../dto/card';
import {FileHelper} from '../../../../helpers/file-helper';
import {MatSnackBar} from '@angular/material/snack-bar';
import {FileImportDialogComponent} from '../../../../shared/file-import-dialog/file-import-dialog.component';
import {EventLogService} from '../../../../services/crud/event-log.service';
import {EventLog} from '../../../../dto/event-log';

@Component({
  selector: 'app-card-renewal-view',
  templateUrl: './card-renewal-view.component.html',
  styleUrls: ['./card-renewal-view.component.css']
})
export class CardRenewalViewComponent implements OnInit {

  import: CardRenewalImport;

  importDataDataSource: MatTableDataSource<CardRenewal>;
  importErrorsDataSource:  MatTableDataSource<CardRenewalImportError>;

  importCols = [
    { header: 'ID',           cell: (row: CardRenewalImport) => `${row.id}`},
    { header: 'Date',         cell: (row: CardRenewalImport) => `${this.datePipe.transform(row.date, DateFormats.DisplayDateTime)}`},
    { header: 'User',         cell: (row: CardRenewalImport) => `${row.username}`},
    { header: 'Invalid rows', cell: (row: CardRenewalImport) => `${row.invalidRowCount}`},
    { header: 'Total rows',   cell: (row: CardRenewalImport) => `${row.totalRowCount}`},
    { header: 'Renewed Cards', cell: (row: CardRenewalImport) => `${row.finishedCardsCount}`},
    { header: 'Cards pending', cell: (row: CardRenewalImport) => `${(row.totalRowCount - row.invalidRowCount) - row.finishedCardsCount}`},
  ];

  importDataCols = [
    { columnDef: 'token',            header: 'Token',           cell: (row: CardRenewal) => `${row.card.token}` },
    { columnDef: 'oldpan',            header: 'PAN Old',           cell: (row: CardRenewal) => `${row.oldMaskedPan || '-'}` },
    { columnDef: 'newpan',            header: 'PAN New',           cell: (row: CardRenewal) => `${row.newMaskedPan || '-'}` },
    { columnDef: 'oldexp',            header: 'Expiry OLD', cell: (row: CardRenewal) => row.oldExpiryDate ? `${this.datePipe.transform(row.oldExpiryDate, DateFormats.DisplayDate)}` : '-'},
    { columnDef: 'newexp',            header: 'Expiry NEW', cell: (row: CardRenewal) => row.newExpiryDate ? `${this.datePipe.transform(row.newExpiryDate, DateFormats.DisplayDate)}` : '-'},
  ];

  importErrorsCols = [
    { columnDef: 'rowNumber',   header: 'Row number',   cell: (row: CardRenewalImportError) => `${row.rowNumber}`},
    { columnDef: 'ParsedValue', header: 'Parsed value', cell: (row: CardRenewalImportError) => `${row.parsedValue}`},
    { columnDef: 'errorText',   header: 'Error Text',   cell: (row: CardRenewalImportError) => `${row.errorText}`},

  ];
  private logs: Array<EventLog>;
  private importId: number;

  constructor(
    private importService: CardRenewalService,
    private route: ActivatedRoute,
    private datePipe: DatePipe,
    private snackBar: MatSnackBar,
    private location: Location,

  ) { }

  loadImportData() {
    this.isLoading = true;
    this.importService.get(this.importId).subscribe(result => {
      this.import = result;
      this.importDataDataSource = new MatTableDataSource(result.cardRenewals);
      this.importErrorsDataSource = new MatTableDataSource(result.importErrors);
      this.isLoading = false;
    });
  }

  ngOnInit() {
    this.importId = parseInt(this.route.snapshot.paramMap.get('id'));
    this.loadImportData();
  }

  getViewLink = (item: CardRenewal): string => '/cards/' + item.card.id.toString();
  isLoading: boolean;
  isImporting: boolean;

  canSeeDownloadCsvButton() {
    return true;
  }

  downloadGeneratedCsv() {
      this.importService.getGeneratedCsv(parseInt(this.route.snapshot.paramMap.get('id'))).subscribe(
        result => {


          FileHelper.saveFile(result);
        },
        err =>
          this.snackBar.open(err.error.message || err.message || err.error || err, null, {
            duration: 5000,
            panelClass: ['app-mat-snack-bar']
          })
      );

  }

  returnBack() {
    this.location.back();
  }

  canSeeUploadCsvField() {
    return true;
  }

  onUploadImportCsv(file: any) {
    this.isLoading = true;
    this.isImporting = true;
    this.importService.uploadImportCsv(file, this.import.id)
      .subscribe(
        result => {

          this.loadImportData();
          this.isLoading = false;
          this.isImporting = false;
        },
        err => {
          this.snackBar.open(err.error.message || err.error || err.message || err, null, {
            duration: 5000,
            panelClass: ['app-mat-snack-bar']
          });
          this.isLoading = false;
          this.isImporting = false;

        }
      );
  }
}
